<template>
  <div class="card-module">
    <div class="module-header">
      <div class="module-title">
        <i class="iconfont icon-a-lujing642" style="font-size: 20px" />
        {{ $t('home.announcementCenter') }}
      </div>
      <!-- 公告类型 Tabs -->
      <div class="notice-tabs">
        <div
          v-for="tab in noticeTypeList"
          :key="tab.type"
          :class="['notice-tab', activeTab === tab.type ? 'active' : '']"
          @click="handleTabClick(tab.type)"
        >
          {{ tab.typeName
          }}<span v-if="tab.count != null" class="notice-tab-count">({{ tab.count }})</span>
        </div>
      </div>
    </div>

    <div class="list-container">
      <div
        v-for="(item, index) in list"
        :key="index"
        :class="['announce-item', typeClass(item.type)]"
      >
        <!-- 置顶标记 -->
        <div v-if="item.isTop" class="top-flag">{{ $t('spareNumberPoo.pinToTop') }}</div>
        <!-- 主内容区：Tag + 时间 + 标题 + 摘要 + 正文 -->
        <div class="main-col">
          <div class="tag-row">
            <div :class="['tag', tagClass(item.type)]">
              {{ item.typeName }}
            </div>
            <div class="date">{{ item.createTime }}</div>
          </div>
          <div class="item-title">
            <div v-if="item.textUrl" class="notice-card-image" @click="getImgSrc(item.textUrl)">
              <el-image :src="item.textUrl" fit="cover" style="width: 100%; height: 100%" />
            </div>
            {{ item.title }}
            <div v-if="item.abstract" class="item-desc">{{ item.abstract || '--' }}</div>
            <div v-if="item.text" class="item-text" v-html="item.text">{{ item.text || '--' }}</div>
          </div>
        </div>
        <!-- 查看按钮：钉在卡片右下角 -->
        <!--        <div class="view-btn" @click="handleView(item)">查看</div>-->
      </div>
    </div>

    <!-- 图片预览 -->
    <ElImageViewer v-if="showViewer" :on-close="closeViewer" :url-list="imgArr" />

    <!-- 系统消息弹框 -->
    <systemMessagePopUp ref="systemMessagePopUpRef" @readMessage="onReadMessage" />
  </div>
</template>

<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
import { getProviderNoticeMsg } from '@/api/newExpressAPI';
import systemMessagePopUp from '@/components/systemMessagePopUp/index.vue';

export default {
  components: {
    ElImageViewer,
    systemMessagePopUp
  },
  data() {
    return {
      activeTab: '',
      list: [],
      normalMessageList: [],
      noticeTypeList: [],
      topMessageList: [], // 置顶消息
      showViewer: false,
      imgArr: []
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 查看图片
    getImgSrc(src) {
      this.imgArr = [src];
      this.showViewer = true;
    },
    // 关闭查看器
    closeViewer() {
      this.showViewer = false;
    },
    // 点击查看：将消息传给系统消息弹框（公告查看场景，关闭时不发已读接口）
    handleView(item) {
      this.$refs.systemMessagePopUpRef.openDialog(item, { skipRead: true });
    },
    // 消息已读回调
    onReadMessage() {
      this.getList();
    },
    // 根据 type 返回卡片整体样式类名
    typeClass(type) {
      if (type === 15) return 'danger';
      if (type === 14) return 'warning';
      if (type === 1) return 'success';
      if (type === 2) return 'normal';
      return 'warning';
    },
    // 根据 type 返回 tag 颜色类名
    tagClass(type) {
      if (type === 15) return 'tag-danger-deep';
      if (type === 14) return 'tag-warning-deep';
      if (type === 1) return 'tag-success-deep';
      if (type === 2) return 'tag-normal-deep';
      return 'tag-warning-deep';
    },
    // 获取公告列表
    getList() {
      const data = {
        messageType: this.activeTab,
        systemType: 1
      };
      getProviderNoticeMsg(data).then((res) => {
        console.log(res, 'getProviderNoticeMsg');
        if (res.code === 200) {
          this.normalMessageList = res.data.normalMessageList || [];
          this.topMessageList = res.data.topMessageList || [];
          // 置顶消息在前，普通消息在后，合并为 list
          this.list = [
            ...this.topMessageList.map((item) => ({ ...item, isTop: true })),
            ...this.normalMessageList
          ];
          // 只有「全部」或首次加载时才更新 tab 列表（保证 count 稳定）
          if (!this.activeTab || !this.noticeTypeList.length) {
            this.noticeTypeList = res.data.noticeTypeList || [];
          }
          // 首次加载时默认选中 noticeTypeList 第一项的 type
          if (
            this.noticeTypeList.length &&
            !this.noticeTypeList.find((item) => item.type === this.activeTab)
          ) {
            this.activeTab = this.noticeTypeList[0].type;
          }
        }
      });
    },
    // tab 切换
    handleTabClick(type) {
      if (this.activeTab === type) return;
      this.activeTab = type;
      this.getList();
    }
  }
};
</script>

<style lang="scss" scoped>
.card-module {
  background: #fff;
  border-radius: 8px;
  padding: 15px;
  height: 600px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.module-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  flex-shrink: 0;
}

.module-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin: 0;
}

.module-title i {
  margin-right: 8px;
  color: #409eff;
}

/* 公告类型 Tabs */
.notice-tabs {
  display: flex;
  align-items: center;
  gap: 10px;
}

.notice-tab {
  padding: 6px 16px;
  border-radius: 20px;
  background: #f3f4f6;
  color: #606266;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
  border: 1px solid transparent;
}

.notice-tab:hover {
  background: #e6e8eb;
}

.notice-tab.active {
  background: #2b6bf6;
  color: #fff;
  font-weight: 600;
}

.notice-tab-count {
  margin-left: 2px;
  font-weight: 500;
}

.list-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding-right: 4px;
}

.list-container::-webkit-scrollbar {
  width: 6px;
}

.list-container::-webkit-scrollbar-thumb {
  background: #dcdfe6;
  border-radius: 3px;
}

.list-container::-webkit-scrollbar-track {
  background: transparent;
}

.announce-item {
  display: flex;
  background: #fafafa;
  border-radius: 6px;
  padding: 16px 18px;
  align-items: flex-start;
  border-left: 4px solid #e6a23c;
  position: relative;
}

/* 紧急公告：红色 */
.announce-item.danger {
  border-left-color: #ee3535;
  background: #fefbfb;
}

/* 运营通知：橙色 */
.announce-item.warning {
  border-left-color: #ff8a00;
  background: #fefbf6;
}

/* 系统更新：蓝色 */
.announce-item.success {
  border-left-color: #18824f;
  background: #f0f9f1;
}

.announce-item.normal {
  border-left-color: #2b6fff;
  background: #f9fbfe;
}

/* 置顶标记 */
.top-flag {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 10;
  padding: 2px 10px;
  background: linear-gradient(135deg, #ff6b6b 0%, #ee3535 100%);
  color: #ffffff;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.5;
  border-radius: 0 0 0 8px;
  box-shadow: 0 2px 4px rgba(238, 53, 53, 0.3);
  letter-spacing: 0.5px;
}

.main-col {
  flex: 1;
  min-width: 0;
}

.tag-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 12px;
}

.tag {
  padding: 3px 12px;
  border-radius: 4px;
  font-size: 12px;
}

/* 标签文字颜色（深色版） */
.tag-danger-deep {
  color: #ee3535;
  background: #ffe8e8;
}

.tag-warning-deep {
  color: #ff8a00;
  background: #fff3e0;
}

.tag-success-deep {
  color: #18824f;
  background: #c6e9d0; /* 加深后的绿色背景 */
}

.tag-normal-deep {
  color: #2b6fff;
  background: #e6efff;
}

.date {
  color: #909399;
  font-size: 13px;
}

.item-title {
  position: relative; /* 为浮动的图片提供定位上下文 */
  color: #2b3e67;
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 6px;
  line-height: 1.5;
  word-wrap: break-word;
  word-break: break-word;
  overflow: hidden; /* 清除浮动 */
}

.item-desc {
  font-size: 13px;
  color: #909399;
  line-height: 1.6;
  margin-bottom: 6px;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-all;
}

.item-text {
  font-size: 14px;
  color: #606266;
  line-height: 1.6;
  //display: -webkit-box;
  //-webkit-line-clamp: 2;
  //-webkit-box-orient: vertical;
  //overflow: hidden;
  //word-break: break-all;
}

.right-col {
  flex-shrink: 0;
  margin-left: 16px;
}

.img-col {
  width: 100px;
  height: 80px;
  background: transparent; /* 去掉原本的浅黄色/白色背景 */
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  overflow: hidden;
}

.view-btn {
  position: absolute;
  right: 18px;
  bottom: 12px;
  padding: 2px 12px;
  border: 1px solid #2b6fff;
  border-radius: 12px;
  font-size: 12px;
  line-height: 1.6;
  color: #2b6fff;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s ease;
}

.view-btn:hover {
  background: #2b6fff;
  color: #fff;
}

.img-col.img-col-danger {
  background: #fefbfb;
}

.img-col.img-col-warning {
  background: #fefbf6;
}

.img-col.img-col-success {
  background: #f9fbfe;
}

.notice-card-image {
  float: right; /* 右浮动，文字自动环绕 */
  width: 150px;
  height: 110px;
  margin: 0 0 8px 12px; /* 上右下左，左边距给文字留空间 */
  .el-image {
    width: 150px;
    height: 110px;
    border: 1px solid #eaeaea;
    border-radius: 6px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    display: block;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
}
</style>
